<template>
  <!-- begin sidebar nav -->
  <div class="menu" v-if="menus">
    <div class="menu-search mb-n3" v-if="appOptions.appSidebarSearch">
      <input type="text" v-on:keyup="handleSidebarFilter" class="form-control" placeholder="Sidebar menu filter..." />
    </div>
    <div class="menu-header">Меню</div>
    <template v-for="menu in menus">
      <sidebar-nav-list ref="sidebarNavList" v-bind:menu="menu" v-bind:scrollTop="scrollTop" v-bind:key="menu.path"
        v-bind:status="menu.status" v-on:collapse-other="handleCollapseOther(menu)"
        v-on:show-float-submenu="handleShowFloatSubmenu" v-on:hide-float-submenu="handleHideFloatSubmenu">
      </sidebar-nav-list>
    </template>

    <!-- BEGIN minify-button -->
    <div class="menu-item d-flex">
      <a href="javascript:;" class="app-sidebar-minify-btn ms-auto" v-on:click="handleSidebarMinify()"><i
          class="fa fa-angle-double-left"></i></a>
    </div>
    <!-- END minify-button -->
  </div>
  <!-- end sidebar nav -->
</template>

<script>
import SidebarNavList from './SidebarNavList.vue'
import AppOptions from '../../config/AppOptions.vue'

export default {
  name: 'SidebarNav',
  props: ['scrollTop'],
  components: {
    SidebarNavList
  },
  data() {
    return {
      menus: [],
      user: {
        jobs_number: {
          ALL: 0,
          PROGRESS: 0,
          REVIEW: 0,
          DECLINED: 0,
          REJECTED: 0,
          CANCELED: 0,
          ACCEPTED: 0,
          ARBITRAGE: 0,
          EXPIRED: 0,
          HIDDEN: 0
        },
        tasks_number: {
          ALL: 0,
          PROGRESS: 0,
          STOPPED: 0,
          DONE: 0,
          MODERATED: 0,
          REJECTED: 0,
          CANCELED: 0
        }
      },
      appOptions: AppOptions
    }
  },
  created() {
    if (localStorage.user) {
      this.user = JSON.parse(localStorage.getItem('user'))
    }

    window.eventBus.$on('user.update', resp => {
      this.user = resp
      this.menus = this.getSidebarMenu()
    })
    this.menus = this.getSidebarMenu()

  },
  methods: {
    getSidebarMenu() {

      this.user = JSON.parse(localStorage.getItem('user'))

      if (!this.user.jobs_number) {
        this.user.jobs_number = {
          ALL: 0,
          PROGRESS: 0,
          REVIEW: 0,
          DECLINED: 0,
          REJECTED: 0,
          CANCELED: 0,
          ACCEPTED: 0,
          ARBITRAGE: 0,
          EXPIRED: 0,
          HIDDEN: 0
        }
      }

      if (!this.user.tasks_number) {
        this.user.tasks_number = {
          ALL: 0,
          PROGRESS: 0,
          STOPPED: 0,
          DONE: 0,
          MODERATED: 0,
          REJECTED: 0,
          CANCELED: 0,
          EXPIRED: 0
        }
      }

      let menu = [
        {
          path: '/jobs', icon: 'fas fa-landmark', title: 'Биржа заданий', children: [
            {path: '/jobs/ALL', title: 'Новые задания', badge: this.user.jobs_number.ALL},
            {path: '/jobs/PROGRESS', title: 'Выполняются ', badge: this.user.jobs_number.PROGRESS},
            {path: '/jobs/REVIEW', title: 'На проверке', badge: this.user.jobs_number.REVIEW},
            {path: '/jobs/DECLINED', title: 'Доработать', badge: this.user.jobs_number.DECLINED},
            {path: '/jobs/EXPIRED', title: 'Время закончилось', badge: this.user.jobs_number.EXPIRED},
            {path: '/jobs/CANCELED', title: 'Невыполненные', badge: this.user.jobs_number.CANCELED},
            {path: '/jobs/REJECTED', title: 'Отказано ', badge: this.user.jobs_number.REJECTED},
            {path: '/jobs/ACCEPTED', title: 'Завершенные', badge: this.user.jobs_number.ACCEPTED},
            {path: '/jobs/HIDDEN', title: 'Скрытые', badge: this.user.jobs_number.HIDDEN},
            {path: '/jobs/ARBITRAGE', title: 'Арбитраж', badge: this.user.jobs_number.ARBITRAGE},
          ]
        },
        {
          path: '/tasks', icon: 'fas fa-table-list', title: 'Мои задания',
          children: [
            {path: '/tasks/ALL', title: 'Все задания', badge: this.user.tasks_number.ALL},
            {path: '/tasks/PROGRESS', title: 'Активные ', badge: this.user.tasks_number.PROGRESS},
            {path: '/tasks/STOPPED', title: 'Остановленные', badge: this.user.tasks_number.STOPPED},
            {path: '/tasks/DONE', title: 'Завершенные', badge: this.user.tasks_number.DONE},
            {path: '/tasks/MODERATED', title: 'На модерации', badge: this.user.tasks_number.MODERATED},
            {path: '/tasks/REJECTED', title: 'Доработать ', badge: this.user.tasks_number.REJECTED},
            {path: '/tasks/CANCELED', title: 'Заблокированные', badge: this.user.tasks_number.CANCELED},
          ]
        },
        {path: '/task/create', icon: 'fas  fa-square-plus', title: 'Добавить задание', label: 'NEW'},
        {
          path: '/payin', icon: 'fas fa-money-bill-1', title: 'Баланс', children: [
            {path: '/payin', title: 'Пополнить счёт'},
            {path: '/pay_histories', title: 'История операций'}
          ]
        },
        {path: '/referral', icon: 'fas  fa-handshake-angle', title: 'Рефералы'},
        {
          path: '/support', icon: 'fas   fa-circle-info', title: 'Помощь',
          children: [ 
            {path: '/support', title: 'Тех.поддержка'},
            {path: '/rules', title: 'Правила'},
            {path: '/howtoscreen', title: 'Как делать скриншот?'}
          ]
        },
      ]
      if (this.user.id == 1) {
        menu.push({
          path: '/admin', icon: 'fas fa-table-list', title: 'Админка',
          children: [
            {path: '/admin', title: 'Сообщения'},
            {path: '/review', title: 'Модерация'},
            {path: '/arbitrage', title: 'Арбитраж'},
            {path: '/admin_payout', title: 'Вывод'},
            {path: '/stats', title: 'Статистика'},
            {path: '/balance', title: 'Баланс'},
          ]
        })
      }
      return menu;
    },
    handleShowFloatSubmenu: function (menu, offset) {
      this.$emit('show-float-submenu', menu, offset);
    },
    handleHideFloatSubmenu: function () {
      this.$emit('hide-float-submenu');
    },
    handleCollapseOther: function (menu) {
      for (var i = 0; i < this.menus.length; i++) {
        this.$refs.sidebarNavList[i].collapse(menu);
      }
    },
    handleSidebarMinify: function () {
      this.appOptions.appSidebarMinified = !this.appOptions.appSidebarMinified;
    },
    handleSidebarFilter: function (e) {
      var value = e.target.value;
      value = value.toLowerCase();

      if (value) {
        for (var x = 0; x < this.menus.length; x++) {
          var title = (this.menus[x].title).toLowerCase();
          var children = this.menus[x].children;

          if (title.search(value) > -1) {
            this.$refs.sidebarNavList[x].show();

            if (children) {
              this.$refs.sidebarNavList[x].searchExpand();
            }
          } else {
            if (children) {
              var hasActive = false;
              for (var y = 0; y < children.length; y++) {
                var title2 = (children[y].title).toLowerCase();

                if (title2.search(value) > -1) {
                  hasActive = true;
                  this.$refs.sidebarNavList[x].$refs.sidebarNavList[y].show();
                  this.$refs.sidebarNavList[x].searchExpand();
                } else {
                  if (hasActive) {
                    this.$refs.sidebarNavList[x].searchExpand();
                  } else {
                    this.$refs.sidebarNavList[x].hide();
                  }
                  this.$refs.sidebarNavList[x].$refs.sidebarNavList[y].hide();
                }
              }
            } else {
              this.$refs.sidebarNavList[x].hide();
            }
          }
        }
      } else {
        for (var a = 0; a < this.menus.length; a++) {
          this.$refs.sidebarNavList[a].show();

          var submenu = this.menus[a].children;
          if (submenu) {
            for (var b = 0; b < submenu.length; b++) {
              this.$refs.sidebarNavList[a].$refs.sidebarNavList[b].show();
            }
          }
        }
      }
      console.log('------');
    }
  }
}
</script>
